/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['./utils'], function(utils) {
    var engineType = {
        combustion: 'combustion',
        electric: 'electric',
        any: 'any'
    };

    function validateIfPointsGreaterOrEqual(speedsAndConsumptions) {
        var sortedKeys = Object.keys(speedsAndConsumptions).sort(function(x, y) {
            return parseFloat(x) > parseFloat(y);
        });
        var keysLength = sortedKeys.length;
        if (speedsAndConsumptions[sortedKeys[0]] > speedsAndConsumptions[sortedKeys[1]]) {
            throw new Error('Consumption for two lowest speeds should be increasing');
        }
        if (speedsAndConsumptions[sortedKeys[keysLength - 2]] > speedsAndConsumptions[sortedKeys[keysLength - 1]]) {
            throw new Error('Consumption for two highest speeds should be increasing');
        }
    }

    function validateFloat(val) {
        if (isNaN(parseFloat(val)) || !isFinite(val)) {
            throw new Error('Expecting float, got: ' + val);
        }
    }

    /**
     * @param {String[]} arr
     */
    function consumptionPairsValidator(arr) {
        var speedsAndConsumptions = {};
        arr.forEach(function(element) {
            var pair = element.split(',');
            if (pair.length !== 2) {
                throw new Error('Invalid number of parameters in the pair around ' + element);
            }
            validateFloat(pair[0]);
            validateFloat(pair[1]);
            if (speedsAndConsumptions.hasOwnProperty(parseFloat(pair[0]))) {
                throw new Error('Duplicate speed: ' + pair[0]);
            } else {
                speedsAndConsumptions[parseFloat(pair[0])] = parseFloat(pair[1]);
            }
        });
        if (Object.keys(speedsAndConsumptions).length > 1) {
            validateIfPointsGreaterOrEqual(speedsAndConsumptions);
        }
    }

    function checkIfCorrectEngineType(obj, type) {
        if (obj.vehicleEngineType && obj.vehicleEngineType !== type && type !== engineType.any) {
            throw new Error('Expecting vehicleEngineType set to ' + type);
        }
    }

    function efficiencyParameterRequired(obj, paramName) {
        if (!(utils.isValidValue(obj.accelerationEfficiency) &&
            utils.isValidValue(obj.decelerationEfficiency) &&
            utils.isValidValue(obj.uphillEfficiency) &&
            utils.isValidValue(obj.downhillEfficiency))) {
            throw new Error('Efficiency parameters are required when using ' + paramName);
        }
    }

    function hasEfficiencyParameterSet(obj) {
        return obj.accelerationEfficiency ||
            obj.decelerationEfficiency ||
            obj.uphillEfficiency ||
            obj.downhillEfficiency;
    }

    function validateDependantParameters(obj, paramName1, paramName2) {
        if (!(obj[paramName1] && obj[paramName2])) {
            throw new Error('Missing dependant parameter. Expecting both defined: ' + paramName1 + ', ' + paramName2);
        }
    }

    function validateEfficiencyParameters(obj, paramName1, paramName2) {
        if (obj[paramName1] * obj[paramName2] > 1) {
            throw new Error('Product of ' + paramName1 + ' and ' + paramName2 + ' cannot exceed 1');
        }
    }

    /**
     * @ignore
     * Consumption Model cannot be used with travelMode values bicycle and pedestrian.
     * @param {Object} obj
     */
    function validateTravelMode(obj) {
        if (obj.travelMode === 'bicycle' || obj.travelMode === 'pedestrian') {
            throw new Error('Consumption model parameters cannot be set if travelMode is set to bicycle or pedestrian');
        }
    }

    /**
     * @ignore
     * All parameters require constantSpeedConsumption* to be specified by the user. It is an
     * error to specify any other consumption model parameter (with the exception of vehicleWeight)
     * if constantSpeedConsumption* is not specified.
     * @param {Object} obj
     */
    function hasConstantSpeedConsumption(obj) {
        if (!obj.constantSpeedConsumptionInLitersPerHundredkm && !obj.constantSpeedConsumptionInkWhPerHundredkm) {
            throw new Error('Consumption model cannot be used without setting constant speed consumption parameter');
        }
    }

    return {
        /**
         * @ignore
         * The list must contain between 1 and 25 points (inclusive), and may not contain
         * duplicate points for the same speed. If it only contains a single point, then the
         * consumption rate of that point is used without further processing.
         * Consumption specified for the largest speed must be greater than or equal to
         * that of the penultimate largest speed. This ensures that extrapolation does not
         * lead to negative consumption rates. Similarly, consumption values specified for the
         * two smallest speeds in the list cannot lead to a negative consumption rate for any smaller speed.
         * The minimum and maximum values described here refer to the valid range for the consumption
         * values (expressed in l/100km.
         * @param {Number} engineType
         * @param {Object} obj
         * @return {Function} function
         */
        constantSpeedConsumption: function(engineType) {
            return function(value, obj) {
                var speedPairs;
                if (value === undefined || value === null) {
                    return;
                }
                validateTravelMode(obj);
                checkIfCorrectEngineType(obj, engineType);
                if (typeof value !== 'string') {
                    throw new TypeError('Expecting a String like "15.2,12.2:8.0,9.0"');
                }
                speedPairs = value.split(':');
                if (speedPairs.length < 1 || speedPairs.length > 25) {
                    throw new Error('Incorrect amount of speed-consumption pairs provided. Expecting 1-25, but got ' +
                        value.length);
                }
                consumptionPairsValidator(speedPairs);
            };
        },
        vehicleWeight: function(value, obj) {
            if (hasEfficiencyParameterSet(obj) && value === undefined) {
                throw new Error('vehicleWeight parameter must be set if any efficiency parameters is present');
            }
        },
        floatAndEngineType: function(engineType, paramName) {
            return function(value, obj) {
                if (!value) {
                    return;
                }
                validateTravelMode(obj);
                hasConstantSpeedConsumption(obj);
                checkIfCorrectEngineType(obj, engineType);
                validateFloat(value);
                if (value < 0) {
                    throw new Error(paramName + ': Expecting positive value');
                }
            };
        },
        fuelEnergyDensityInMJoulesPerLiter: function(value, obj) {
            if (!value) {
                return;
            }
            validateTravelMode(obj);
            validateFloat(value);
            hasConstantSpeedConsumption(obj);
            checkIfCorrectEngineType(obj, 'combustion');
            efficiencyParameterRequired(obj, 'fuelEnergyDensityInMJoulesPerLiter');
        },
        /**
         * @ignore
         * accelerationEfficiency and decelerationEfficiency must always be specified as a pair (i.e. both or none).
         * uphillEfficiency and downhillEfficiency must always be specified as a pair (i.e. both or none).
         * If accelerationEfficiency and decelerationEfficiency are specified,
         * product of their values must not be greater than 1 (to prevent perpetual motion).
         * If uphillEfficiency and downhillEfficiency are specified, product of their
         * values must not be greater than 1 (to prevent perpetual motion).
         * @param {Number} paramName1
         * @param {Number} paramName2
         * @return {undefined} undefined
         */
        efficiencyParameter: function(paramName1, paramName2) {
            return function(value, obj) {
                if (!value) {
                    return;
                }
                validateTravelMode(obj);
                hasConstantSpeedConsumption(obj);
                checkIfCorrectEngineType(obj, engineType.any);
                validateDependantParameters(obj, paramName1, paramName2);
                /**
                 * @ignore
                 * If *Efficiency parameters are specified by the user, then vehicleWeight must also be specified.
                 */
                validateDependantParameters(obj, paramName1, 'vehicleWeight');
                /**
                 * @ignore
                 * When vehicleEngineType is combustion, fuelEnergyDensityInMJoulesPerLiter must be specified as well.
                 */
                if (obj.vehicleEngineType === engineType.combustion) {
                    validateDependantParameters(obj, paramName1, 'fuelEnergyDensityInMJoulesPerLiter');
                }
                validateEfficiencyParameters(obj, paramName1, paramName2);
                validateFloat(value);
            };
        },
        chargeParameter: function(paramName1, paramName2) {
            return function(value, obj) {
                if (!value) {
                    return;
                }
                validateTravelMode(obj);
                hasConstantSpeedConsumption(obj);
                checkIfCorrectEngineType(obj, engineType.electric);
                validateDependantParameters(obj, paramName1, paramName2);
                validateFloat(value);
            };
        },
        budgetInRange: function(value, data) { // eslint-disable-line no-unused-vars
            var maxBudget;
            var currentBudgetProvided;
            var electricEngine = data.vehicleEngineType === 'electric';
            if (electricEngine) {
                maxBudget = data.currentChargeInkWh;
                currentBudgetProvided = data.energyBudgetInkWh;
                if (currentBudgetProvided > maxBudget) {
                    throw new Error('Energy budget may not be greater than current energy.');
                }
            } else {
                maxBudget = data.currentFuelInLiters;
                currentBudgetProvided = data.fuelBudgetInLiters;
                if (currentBudgetProvided > maxBudget) {
                    throw new Error('Fuel budget may not be greater than current fuel.');
                }
            }
            if (currentBudgetProvided < 0) {
                throw new Error('Budget may not be negative.');
            }
        },
        requiredBudget: function(value, data) { // eslint-disable-line no-unused-vars
            var liters = data.fuelBudgetInLiters;
            var watts = data.energyBudgetInkWh;
            var time = data.timeBudgetInSec;
            if ([liters, watts, time].filter(
                function(n) {
                    return n !== undefined;
                }).length > 1) { // both true or false -> logical xor
                throw new Error('Exactly one of fuelBudgetInLiters and energyBudgetInkWh and timeBudgetInSec must be set.'); // eslint-disable-line
            }
        },
        requiredWithSpecificEngineType: function(value, data, key) {
            var consumptionInLiters = 'constantSpeedConsumptionInLitersPerHundredkm' in data;
            var consumptionInWatts = 'constantSpeedConsumptionInkWhPerHundredkm' in data;
            var electricEngine = data.vehicleEngineType === 'electric';

            if (key === 'energyBudgetInkWh' && value) {
                if (!electricEngine) {
                    throw new Error('Engine type should be "electric" when energyBudgetInkWh is set');
                }
                if (!consumptionInWatts) {
                    throw new Error('Missing constant speed consumption for electric engine.');
                }
            } else if (key === 'fuelBudgetInLiters' && value) {
                if (electricEngine) {
                    throw new Error('Engine type should be "combustion" or undefined when fuelBudgetInLiters is set');
                }
                if (!consumptionInLiters) {
                    throw new Error('Missing constant speed consumption for combustion engine.');
                }
            }
        },
        notCommon: function(value, data, key) { // eslint-disable-line no-unused-vars
            var forbiddenAvoids = ['alreadyUsedRoads'];
            var forbiddenModes = ['bicycle', 'pedestrian'];
            if ('arriveAt' in data ||
                ('avoid' in data && forbiddenAvoids.indexOf(data.avoid) >= 0) ||
                ('travelMode' in data && forbiddenModes.indexOf(data.travelMode) >= 0)
            ) {
                throw new Error(key + ' parameter is not allowed in Calculate Reachable Route request');
            }
        },
        firstParamCannotBeUsedWithSecond: function(paramNameUsed, paramNameToAvoid) {
            return function(value, obj) {
                if (!value) {
                    return;
                }
                if (obj.hasOwnProperty(paramNameToAvoid) && utils.isValidValue(obj[paramNameToAvoid])) {
                    throw new Error(paramNameUsed + ' parameter cannot be used in conjunction with ' +
                        paramNameToAvoid);
                }
            };
        },
        requiresDependantParameter: function(parameterName, dependantParameter) {
            return function(value, obj) {
                if (!value) {
                    return;
                }
                if (!obj.hasOwnProperty(dependantParameter)) {
                    throw new Error(dependantParameter + ' must be specified when using with ' + parameterName);
                }
            };
        }
    };
});



// WEBPACK FOOTER //
// ./services/postValidators.js